import { HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

export enum TimeFormat {
  Hour24 = '24',
  Hour12 = '12',
}

export abstract class OnboardingAppStore<T extends OnboardingCommonStore> {
  public abstract state$: Observable<T>;
  public abstract patchState(state: Partial<T>): void;
  public abstract get token(): string | null;
  public abstract get lang(): string | null;
}

export interface OnboardingCommonStore {
  lang: string | null;
  timeFormat: TimeFormat | null;
  token: string | null;
  loading: boolean | null;
  error: HttpErrorResponse | null;
  finished: boolean;
  authorizationCode: string | null;
  progress: {
    pct: number;
    visible: boolean;
  };
}

export type OnboardingFlow = 'company' | 'user';
